import { isSupportedBrowser, setBackgroundColor } from '@el5/native-api'
import React, { useLayoutEffect } from 'react'
import { Route, Router, Switch } from 'wouter'

import { GlobalErrorBoundary } from '@/components/GlobalErrorBoundary'
import { ThemeProvider } from '@/components/ThemeProvider/provider'
import { Toaster } from '@/components/Toaster/toaster'

import { NetworkStatus } from './components/NetworkStatus'
import { Esum } from './pages/Esum'
import { EsumOffer } from './pages/EsumOffer'
import { NotFound } from './pages/NotFound'
import { customerStore } from './store/CustomerStore'

const BASE_URL = import.meta.env.VITE_BASE_URL ?? '/'

export const App = () => {
  React.useEffect(() => {
    customerStore.getAccessToken()
  }, [])

  useLayoutEffect(() => {
    if (isSupportedBrowser()) {
      setBackgroundColor('#eff1f5')
    }

    return () => {
      if (isSupportedBrowser()) {
        setBackgroundColor('#fff')
      }
    }
  }, [])

  return (
    <ThemeProvider>
      <GlobalErrorBoundary>
        <NetworkStatus>
          <Router base={BASE_URL}>
            <Switch>
              <Route path="/esum" component={Esum} />
              <Route path="/esum/:id" component={EsumOffer} />

              <Route component={NotFound} />
            </Switch>
          </Router>
          <Toaster />
        </NetworkStatus>
      </GlobalErrorBoundary>
    </ThemeProvider>
  )
}
